import React, { FC } from "react";
import {
  FacebookShareButton,
  FacebookIcon,
  PinterestShareButton,
  PinterestIcon,
  TwitterShareButton,
  TwitterIcon
} from "react-share";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { appSettings } from "../../../config/app";
import { ENV_CONFIG } from "../../../config/env";
import { isMobile } from "../../../util";

import View from "../../../components/common/view";
import { ShareInfoProp } from "../types";

const PINTEREST_WINDOW_WIDTH = 1000;
const PINTEREST_WINDOW_HEIGHT = 730;
const ICON_SIZE = 34;

const ShareInfo: FC<ShareInfoProp> = ({ pinterestImage, onMethodClick }) => {
  const { t } = useTranslation("productDetails");
  const location = useLocation();

  const shareUrl = `${ENV_CONFIG.baseURL}${location.pathname}`;
  const pinterestMediaUrl = `${appSettings.imageBaseURL}${pinterestImage}?w=800&h=858&quality=95&mode=crop`;

  const handleShare = () => {
    navigator
      .share({ url: shareUrl })
      .then(() => console.info("Successful share"))
      .catch(error => console.error("Error sharing", error));
  };

  const onShareClick = () => {
    if (navigator?.share && isMobile.any()) {
      handleShare();
    }
  };

  return (
    <div className="share_zoom_wrap">
      <View.desktop className="share_over">
        Share
        <div className="social_share" onClick={onMethodClick}>
          <span data-share="facebook">
            <FacebookShareButton url={shareUrl}>
              <FacebookIcon size={ICON_SIZE} round />
            </FacebookShareButton>
          </span>
          <span data-share="pinterest">
            <PinterestShareButton
              url={shareUrl}
              media={pinterestMediaUrl}
              windowWidth={PINTEREST_WINDOW_WIDTH}
              windowHeight={PINTEREST_WINDOW_HEIGHT}
            >
              <PinterestIcon size={ICON_SIZE} round />
            </PinterestShareButton>
          </span>
          <span data-share="twitter">
            <TwitterShareButton url={shareUrl}>
              <TwitterIcon size={ICON_SIZE} round />
            </TwitterShareButton>
          </span>
        </div>
      </View.desktop>

      <View.mobile className="share_over" onClick={onShareClick}>
        Share
      </View.mobile>

      <span className="zoom_over">{t("zoomText")}</span>
    </div>
  );
};

export default ShareInfo;
